import axios, { AxiosRequestConfig } from 'axios';
import { decode } from 'jsonwebtoken-esm';
import { isUndefined, once } from 'lodash-es';

const AUTH_HEADER = import.meta.env.VITE_AUTH_HEADER || '';

export const defaultAllowRequestUrl: string[] = [
  '/oversea-hi/v1/review/stat',
  '/trade/v2/queryReturnList',
  'overseaim-store-home/org-region-config/v1/query',
  'overseaim-hi/v1/queryStoreList',
  '/api_gateway/dashboard/performance/order/overview',
  '/api_gateway/dashboard/performance/sales/convert',
  '/api_gateway/dashboard/performance/order/loss',
  '/api_gateway/dashboard/performance/order/recovery',
  '/api_gateway/dashboard/performance/order/reasons',
  '/api_gateway/dashboard/performance/comment',
  '/overseaim-hi/v1/review/search',
  'getTalkInfoByBuyerStore',
  '/oversea-conversation/v1/syncMessage',
  '/overseaim-hi/userSendHistory/query',
  'api_gateway/dashboard/assistant/performance',
  'api_gateway/dashboard/robot/contribution/conversation/outline',
  '/api_gateway/dashboard/assistant/export/performance',
  'api_gateway/dashboard/robot/contribution/conversation',
  'api_gateway/dashboard/robot/contribution/order/reminder',
  'api_gateway/dashboard/robot/contribution/payment/reminder',
  'api_gateway/dashboard/robot/contribution/cancel/order/reminder',
  'api_gateway/dashboard/robot/contribution/praise/reminder',
  'api_gateway/dashboard/robot/contribution//auto/review',
  'api_gateway/dashboard/robot/contribution/export/robot/contribution',
  '/oversea-user-voice/v1/case/list',
  'api_gateway/dashboard/assistant/performance/v2',
  '/api_gateway/dashboard/assistant/dashboard/reception-score/stats/auth',
  'aggregation/v1/assistant_tunnels',
  '/translate',
  'api_gateway/dashboard/assistant/performance/v3',
  '/oversea-conversation/v1/advanceQueryConversationList',
  '/oversea-conversation/v1/advanceQueryRemindConversationList',
  '/api_gateway/dashboard/assistant/auth',
  '/api_gateway/dashboard/reception-score/stats',
  '/overseaim-store-home/v1/assistant/page-list',
  '/aggregation/v1/advanceQueryConversationList',
  '/aggregation/v1/getImportantTodoConversationList',
  '/item/v4/items/search',
  '/api_gateway/dashboard/performance/rank',
  '/aggregation/v1/getAggTalkByBuyerStore',
  '/api_gateway/dashboard/robot/contribution/msg/reply',
  '/translate?from=chat',
  '/translate?from=sid',
  '/translate?from=gpt4TranslateTool',
  '/review_analyzer/v1/overview',
  '/review_analyzer/v1/overview/negative',
  '/review_analyzer/v1/overview/negative/attribution',
  '/review_analyzer/v1/overview/negative/item',
  '/review_analyzer/v1/tags',
  '/review_analyzer/v1/tagsGroupByItem',
  '/review_analyzer/v1/reviews',
  '/review_analyzer/v1/items',
  '/oversea-buyer-offline/v1/getHighRiskBuyers',
  '/oversea-buyer-offline/v1/getMaliciousBuyers',
  '/oversea-knowledge/supplemental_knowledge/list',
  '/oversea-knowledge/activity_knowledge/activities/list',
];

const fetchAllowList = once(() => {
  return axios
    .get('https://clients.zhisuitech.com/fett-public/sellerDemoWhitelist.json', {
      timeout: 5000,
    })
    .then((res) => res.data.sellerDemoWhitelistUrls)
    .catch(() => {
      return defaultAllowRequestUrl;
    });
});

let _isSeller: boolean | undefined;

const isSeller = (config: AxiosRequestConfig) => {
  if (!isUndefined(_isSeller)) {
    return _isSeller;
  }

  const { headers } = config;
  const authorization = headers?.[AUTH_HEADER] || '';
  const token = authorization.replace('Bearer ', '');
  if (!token) {
    _isSeller = false;
    return _isSeller;
  }
  const payload: any = decode(token, { json: true });
  _isSeller = payload?.leyan_user?.userType === 'seller';
  return _isSeller;
};

export const forbiddenSellerAction = async (config: AxiosRequestConfig) => {
  const allowRequestUrl = await fetchAllowList();
  if (
    isSeller(config) &&
    config.method?.toLowerCase() !== 'get' &&
    !allowRequestUrl.includes(config.url || '')
  ) {
    return {
      ...config,
      adapter(cfg: AxiosRequestConfig) {
        return Promise.resolve({
          data: {},
          status: 200,
          statusText: '',
          headers: config.headers,
          config,
        });
      },
    };
  }
  return config;
};
